import {Component, Input, Output, EventEmitter, OnInit, OnChanges, DoCheck, SimpleChanges} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EscalationServices} from '../../shared/services/src/api/escalation.services';
import {ObjectUtils, StringUtils} from '../../shared/utils';
import { RouterUtils } from '../../shared/utils/src/router.utils';
import {AuthServices} from '../../shared/authentications/src/auth.services';

@Component({
    selector: 'escalation-rule-view',
    templateUrl: './escalation-rule-view.component.html',
    styleUrls: ['./rule.component.scss'],
    providers: [EscalationServices]
})

export class EscalationRuleViewComponent implements OnInit, OnChanges, DoCheck {
    @Input() public escaLPlcyInfo: any;
    private stepInfo: any;
    params = { escalPlcyNo: 0 };

    constructor(private _escalationServices: EscalationServices,
                private activateRoute: ActivatedRoute,
                public authService: AuthServices,
                private _router: Router) {
    }

    ngOnInit() { }

    ngOnChanges(changes: SimpleChanges) {
        // const chng = changes['escaLPlcyInfo'];
        //
        // if (chng !== undefined && chng.currentValue !== undefined && chng.currentValue !== chng.previousValue) {
        //     if (chng.currentValue.stepInfo !== undefined) {
        //         this.stepInfo = chng.currentValue.stepInfo;
        //         console.log(`에스컬레이션룰 stepInfo : ${JSON.stringify(this.stepInfo)}`);
        //     }
        // }

        // if (this.escaLPlcyInfo.stepInfo !== undefined) {
        //     console.log(`에스컬레이션룰 stepInfo : ${JSON.stringify(this.escaLPlcyInfo.stepInfo)}`);
        // }
    }

    ngDoCheck() {
        this.params = JSON.parse(decodeURIComponent(this.activateRoute.snapshot.params['option']));
    }

    public ModifyEscalationRule() {
        RouterUtils.navigate(this._router, '/escalation/modify-policy', this.params);
        // 에스컬레이션에 매핑된 서비스, 인티그레이션이 존재하는지 체크
        // this.getEscalationInfo();
    }

    /* 에스컬레이션 상세 조회 */
    // 에스컬레이션 스냅샷을 만들기 때문에 현재 사용 안 함.
    public getEscalationInfo() {
        this._escalationServices.getEscalationInfo(this.escaLPlcyInfo.escalPlcyNo).then(result => {
            if (result.status === 200) {
                // 에스컬레이션 상세 데이터
                this.escaLPlcyInfo = result.json().data;

                if (this.escaLPlcyInfo.targets.length > 0) {
                    $.magnificPopup.open({
                        items: {
                            src: '#modifyEscalPlcyPopup',
                        },
                    });
                } else {
                    RouterUtils.navigate(this._router, '/escalation/modify-policy', this.params);
                }
            }
        });
    }

    isShowEmailTooltip(receiver) {
        return receiver.rcvrEmail && receiver.rcvrEmail !== receiver.rcvrNm && StringUtils.isEmail(receiver.rcvrEmail);
    }

    // 팝업 클로즈
    cancel() {
        $.magnificPopup.close();
    }


    // 응답자 조건 보기/가리기
    viewOptionResponder (index) {
        this.escaLPlcyInfo.stepInfo[index].isViewOptionResponder =  !!this.escaLPlcyInfo.stepInfo[index].isViewOptionResponder ? false : true;

    }
}





// WEBPACK FOOTER //
// ./src/app/components/escalation-rule/escalation-rule-view.component.ts